"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=ILanguage.js.map